import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { IvrService } from '../ivr.service';
import { Msisdn } from '../../shared/msisdn/msisdns';

@Injectable()
export class IvrMsisdnsResolver implements Resolve<Msisdn[]> {
  constructor(private ivrService: IvrService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Msisdn[]> | Promise<Msisdn[]> | Msisdn[] {
    const id = route.paramMap.get('id');
    return this.ivrService.getMsisdnsAssignedToIvr(id);
  }
}
